import ReactGA from 'react-ga4';

import { useMixpanelAnalytics } from '@shared/hooks/analytics/useMixpanelAnalytics';
import { useAppSelector } from '@shared/hooks/redux';

import type { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import type { RootState } from '@store/store';

export type EventData = {
  event: AnalyticsEventEnum;
  isConversion?: boolean;
  [key: string]: any;
};

export type AnalyticsEventTracker = (eventData: EventData) => void;

const useAnalyticsEventTracker = (): AnalyticsEventTracker => {
  const analytics = useMixpanelAnalytics();
  const profileInfo = useAppSelector((state: RootState) => state.profile?.data);
  return (eventData: EventData) => {
    if (eventData.event.includes('Chat')) {
      return () => true;
    }

    if (process.env.REACT_APP_ENV === 'production') {
      analytics.trackEvent(eventData.event, {
        ...eventData,
        $user_id: profileInfo?.id,
        user_id: profileInfo?.id,
        plan: profileInfo?.subscription?.package,
        timestamp: Date.now(),
      });

      ReactGA.event(eventData.event || '', {
        category: 'web-app',
        action: eventData.event || '',
        label: eventData.event || '',
        ...eventData,
      });
    } else {
      return () => true;
    }
  };
};
export default useAnalyticsEventTracker;
